<template>
  <div class="info-page">
    <crumbs title="成果管理" />
    <el-form
      :model="form"
      :rules="rules"
      ref="ruleForm"
      label-position="right"
      label-width="100px"
      :disabled="isAudit"
    >
      <div class="info-page__item">
        <div class="info-page__title">
          <span>发布人信息</span>
        </div>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="认证类型" prop="imCertificationType">
              <enumerate
                v-model="form.imCertificationType"
                url="/api/user/usercertypeenum"
                placeholder="请选择认证类型"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <template v-if="form.imCertificationType === 1">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="联系人姓名" prop="contact">
                <el-input
                  v-model="form.contact"
                  placeholder="请输入联系人姓名"
                  maxlength="15"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系电话" prop="phoneNumber">
                <el-input
                  v-model="form.phoneNumber"
                  placeholder="请填写手机或固定座机 如：010-87654321"
                  maxlength="13"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="所属地区" prop="regionAddress">
                <region
                  v-model="form.regionAddress"
                  placeholder="请选择所属地区"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        <template v-if="form.imCertificationType === 2">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="企业名称" prop="companyName">
                <el-input
                  v-model="form.companyName"
                  placeholder="请输入单位名称"
                  maxlength="50"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="所属地区" prop="regionAddress">
                <region
                  v-model="form.regionAddress"
                  placeholder="请选择所属地区"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item label="详细地址" prop="address">
                <el-input
                  v-model="form.address"
                  placeholder="请输入详细地址"
                  maxlength="50"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="联系人姓名" prop="contact">
                <el-input
                  v-model="form.contact"
                  placeholder="请输入联系人姓名"
                  maxlength="15"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系电话" prop="phoneNumber">
                <el-input
                  v-model="form.phoneNumber"
                  placeholder="请填写手机或固定座机 如：010-87654321"
                  maxlength="13"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
      </div>
      <!-- 产品成果 -->
      <div class="info-page__item" v-if="isProd">
        <div class="info-page__title">
          <span>产品详细信息</span>
        </div>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="产品名称" prop="name">
              <el-input
                v-model="form.name"
                placeholder="请输入名称"
                maxlength="50"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item
              label="产品图片"
              prop="imgUploadList"
              :rules="{
                required: true,
                message: '请上传产品图片'
              }"
            >
              <image-upload
                url="/api/Achievement/UploadAchiAttach"
                accept="image/jpeg,image/png,image/bmp,image/webp"
                :file-list.sync="form.imgUploadList"
                :multiple="false"
                :num-limit="1"
                :size-limit="10"
              >
                <template>
                  <el-alert
                    :title="`上传图片格式要求 jpg、jpeg、webp、bmp、png；图片比例为1：1；每个大小不超过10MB；图片名(包含后缀名)的最大长度为100个字符。`"
                    type="warning"
                  >
                  </el-alert>
                </template>
              </image-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="专业领域" prop="specialFieldId">
              <enumerate
                v-model="form.specialFieldId"
                url="/api/achievement/getimproductfield"
                placeholder="请选择专业领域"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="16">
            <el-form-item label="技术关键词" prop="keywordList">
              <el-select
                v-model="form.keywordList"
                filterable
                allow-create
                default-first-option
                multiple
                :multiple-limit="5"
                clearable
                placeholder="请输入自定义创建的技术关键词"
                no-data-text="请输入技术关键词，输入长度不能大于20，按回车键确认创建，最多创建5个关键字"
                style="width: 100%"
              >
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="产品介绍" prop="description">
              <el-input
                v-model="form.description"
                type="textarea"
                :autosize="{ minRows: 3 }"
                placeholder="请输入产品介绍"
                maxlength="2000"
                show-word-limit
                resize="none"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="应用场景" prop="applicationScenario">
              <el-input
                v-model="form.applicationScenario"
                type="textarea"
                :autosize="{ minRows: 3 }"
                placeholder="请输入应用场景"
                maxlength="2000"
                show-word-limit
                resize="none"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="附件上传" prop="fileUploadList">
              <file-upload
                url="/api/Achievement/UploadAchiAttach"
                :file-list.sync="form.fileUploadList"
                accept="text/plain,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                :num-limit="5"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <!-- 技术成果 -->
      <div class="info-page__item" v-else>
        <div class="info-page__title">
          <span>成果详细信息</span>
        </div>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="成果名称" prop="name">
              <el-input
                v-model="form.name"
                placeholder="请输入名称"
                maxlength="50"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="专业领域" prop="specialFieldId">
              <enumerate
                v-model="form.specialFieldId"
                url="/api/achievement/getimspecialfield"
                placeholder="请选择专业领域"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="技术成熟度" prop="technicalMaturity">
              <enumerate
                v-model="form.technicalMaturity"
                placeholder="请选择技术成熟度"
                url="/api/Achievement/GetTecMaturity"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="16">
            <el-form-item label="先进程度" prop="advancedLevel">
              <enumerate-radio
                v-model="form.advancedLevel"
                custom-style="card"
                url="/api/Achievement/GetAdvanceLevel"
                default-value="国内先进"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="截止时间" prop="closingTime">
              <el-date-picker
                v-model="form.closingTime"
                type="date"
                placeholder="请选择截止时间"
                value-format="yyyy-MM-dd"
                prefix-icon="el-icon-date"
                style="width: 100%"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="16">
            <el-form-item label="技术关键词" prop="keywordList">
              <el-select
                v-model="form.keywordList"
                filterable
                allow-create
                default-first-option
                multiple
                :multiple-limit="5"
                clearable
                placeholder="请输入自定义创建的技术关键词"
                no-data-text="请输入技术关键词，输入长度不能大于20，按回车键确认创建，最多创建5个关键字"
                style="width: 100%"
              >
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="成果概述" prop="description">
              <el-input
                v-model="form.description"
                type="textarea"
                :autosize="{ minRows: 3 }"
                placeholder="请输入成果概述"
                maxlength="2000"
                show-word-limit
                resize="none"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="应用场景" prop="applicationScenario">
              <el-input
                v-model="form.applicationScenario"
                type="textarea"
                :autosize="{ minRows: 3 }"
                placeholder="请输入应用场景"
                maxlength="2000"
                show-word-limit
                resize="none"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="技术指标" prop="technologyInfo">
              <el-input
                v-model="form.technologyInfo"
                type="textarea"
                :autosize="{ minRows: 3 }"
                placeholder="请输入成果的技术参数"
                maxlength="2000"
                show-word-limit
                resize="none"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row
          :gutter="10"
          v-for="(item, index) in form.applicationList"
          :key="index"
        >
          <el-col :span="8">
            <el-form-item
              :label="index === 0 ? '专利号' : ''"
              :prop="`applicationList[${index}]`"
              :rules="isPatentNumber"
            >
              <el-input
                v-model="form.applicationList[index]"
                placeholder="请输入专利号"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <template v-if="index === form.applicationList.length - 1">
              <el-button
                plain
                type="primary"
                icon="el-icon-plus"
                circle
                :disabled="applicationListHasEmpty"
                @click.prevent="addApplicationNumber"
              ></el-button>
            </template>
            <template v-else>
              <el-button
                plain
                type="warning"
                icon="el-icon-minus"
                circle
                @click.prevent="removeApplicationNumber(index)"
              ></el-button>
            </template>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="成果图片" prop="imgUploadList">
              <image-upload
                url="/api/Achievement/UploadAchiAttach"
                accept="image/jpeg,image/png,image/bmp,image/webp"
                :file-list.sync="form.imgUploadList"
                :num-limit="5"
                :size-limit="10"
              >
                <template>
                  <el-alert
                    :title="`上传图片格式要求 jpg、jpeg、webp、bmp、png；最多可上传5个图片，每个大小不超过10MB；图片名(包含后缀名)的最大长度为100个字符。`"
                    type="warning"
                  >
                  </el-alert>
                </template>
              </image-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="附件上传" prop="fileUploadList">
              <file-upload
                url="/api/Achievement/UploadAchiAttach"
                :file-list.sync="form.fileUploadList"
                accept="text/plain,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                :num-limit="5"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <template v-if="isAudit">
      <div class="info-page__item">
        <div class="info-page__title">
          <span>审核操作</span>
        </div>
        <el-form
          :model="auditForm"
          ref="auditForm"
          label-position="right"
          label-width="100px"
        >
          <el-row>
            <el-form-item label="审核通过" required>
              <el-switch
                v-model="auditForm.isPass"
                active-text="是"
                inactive-text="否"
              >
              </el-switch>
            </el-form-item>
          </el-row>
          <el-row v-if="!auditForm.isPass">
            <el-form-item
              label="备注"
              prop="appDec"
              :rules="{
                required: true,
                message: '请填写不通过原因'
              }"
            >
              <el-input
                v-model="auditForm.appDec"
                placeholder="请填写不通过原因"
                maxlength="50"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-row>
        </el-form>
      </div>
      <div class="submit fn-text-center mt-20">
        <el-button
          type="primary"
          :loading="isLoading"
          plain
          @click="handlerAuditData('auditForm')"
          >提交</el-button
        >
      </div>
    </template>
    <template v-else>
      <div class="submit fn-text-center mt-20">
        <template v-if="isAdd">
          <el-button
            type="primary"
            :loading="isLoading"
            plain
            @click="handlerAddData('ruleForm')"
            >提交</el-button
          >
        </template>
        <template v-else>
          <el-button
            type="primary"
            :loading="isLoading"
            plain
            @click="handlerModifyData('ruleForm')"
            >提交</el-button
          >
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import CheckObj from "@/utils/check.js";
export default {
  name: "achievementInfo",
  data() {
    const isEmpty = (
      message = "该项值不能为空",
      trigger = ["blur", "change"]
    ) => {
      return {
        required: true,
        message,
        trigger
      };
    };
    return {
      // 是否是产品成果
      isProd: false,
      // 是否处于loading状态
      isLoading: false,
      //是添加数据还是修改数据
      isAdd: true,
      // 是否是审核
      isAudit: false,
      //表单
      form: {
        // 发布人信息
        imCertificationType: "",
        companyName: "",
        regionAddress: [],
        address: "",
        contact: "",
        phoneNumber: "",
        // 详细信息
        name: "",
        specialFieldId: "", // integer
        technicalMaturity: "", // integer
        advancedLevel: "", // integer
        closingTime: "",
        description: "",
        applicationScenario: "",
        technologyInfo: "",
        keywordList: [], // technologyKeyword 相对应 分号分隔
        // 专利号
        applicationList: [""], // applicationNumber 相对应 分号分隔
        imgUploadList: [], // imgFiles 相对应
        fileUploadList: [] // attachFiles 相对应
      },
      rules: {
        imCertificationType: [isEmpty("请选择认证类型", "change")],
        companyName: [isEmpty("请输入单位名称")],
        regionAddress: [isEmpty("请选择所属地区", "change")],
        address: [isEmpty("请输入详细地址")],
        contact: [
          isEmpty("请输入联系人姓名"),
          {
            validator: (rule, value, callback) => {
              if (value && !CheckObj.checkChineseName(value)) {
                return callback(new Error("请输入正确的中文姓名"));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        phoneNumber: [
          isEmpty("请输入联系电话"),
          {
            validator: (rule, value, callback) => {
              if (
                value &&
                !CheckObj.checkPhone(value) &&
                !CheckObj.checkTelephone(value)
              ) {
                return callback(new Error("请输入正确的电话号码"));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        name: [isEmpty("请输入名称")],
        specialFieldId: [isEmpty("请选择专业领域", "change")],
        technicalMaturity: [isEmpty("请选择技术成熟度", "change")],
        advancedLevel: [isEmpty("请选择先进程度", "change")],
        closingTime: [
          {
            validator: (rule, value, callback) => {
              if (value && Date.now() - Date.parse(value) > 0) {
                return callback(new Error("截止时间不可以早于当前时间"));
              }
              callback();
            },
            trigger: "change"
          }
        ],
        description: [isEmpty("请输入详细描述")],
        keywordList: [
          isEmpty("请输入技术关键词", "change"),
          {
            validator: (rule, value, callback) => {
              const bool = value.some((item) => {
                return item.length > 20;
              });
              if (bool) {
                return callback(new Error("输入长度不能大于20"));
              }
              callback();
            },
            trigger: "change"
          }
        ]
      },
      // 校验是否是专利号
      isPatentNumber: {
        validator: (rule, value) => {
          return new Promise((resolve, reject) => {
            if (value && !CheckObj.checkPatentNumber(value)) {
              reject(new Error("请输入正确的专利号"));
            } else {
              resolve();
            }
          });
        },
        trigger: "blur"
      },
      // 是否通过
      auditForm: {
        isPass: false,
        appDec: ""
      }
    };
  },
  computed: {
    // applicationList是否有空项目
    applicationListHasEmpty() {
      return this.form.applicationList.some((item) => {
        return item.trim() === "";
      });
    }
  },
  created() {
    this.isProd = this.$route.query.achvType === "prod";
    const { method } = this.$route.params;
    // 默认值 走添加流程
    let isAdd = true,
      isAudit = false;
    if (method === "audit") {
      //获取信息
      this.loadInfo();
      //走审核流程
      isAudit = true;
    } else if (method === "modification") {
      //获取信息
      this.loadInfo();
      //走修改流程
      isAdd = false;
    }
    this.isAdd = isAdd;
    this.isAudit = isAudit;
  },
  methods: {
    // 添加删除专利号
    addApplicationNumber() {
      // if (this.form.applicationList.length > 4) return;
      this.form.applicationList.push("");
    },
    removeApplicationNumber(index) {
      this.form.applicationList.splice(index, 1);
    },
    // 正向处理数据 将数据处理后提交
    processDataSubmit() {
      const {
        // integer
        specialFieldId,
        technicalMaturity,
        advancedLevel,
        // list
        regionAddress,
        keywordList,
        applicationList,
        imgUploadList,
        fileUploadList,
        ...others
      } = this.form;
      // 处理 regionAddress
      const [provinceCode = "", cityCode = "", districtCode = ""] =
        regionAddress;
      // 处理 applicationList
      const applicationNumber = applicationList
        .filter((item) => {
          return item !== "";
        })
        .join(";");
      // 处理 keywordList
      const technologyKeyword = keywordList.join(";");
      // 处理上传文件
      const deconstruct = (file = {}) => {
        return file.response ? file.response.dataList[0] : file;
      };
      const turnFile = {
        imgFiles: imgUploadList,
        attachFiles: fileUploadList
      };
      Object.keys(turnFile).map((key) => {
        turnFile[key] = turnFile[key].map((item) => {
          return deconstruct(item);
        });
      });
      // 处理字符串 转为数字
      const turnNumber = {
        specialFieldId,
        technicalMaturity,
        advancedLevel
      };
      Object.keys(turnNumber).map((key) => {
        turnNumber[key] = turnNumber[key] === "" ? -1 : turnNumber[key];
      });
      return {
        ...others,
        ...turnNumber,
        ...turnFile,
        provinceCode,
        cityCode,
        districtCode,
        technologyKeyword,
        applicationNumber
      };
    },
    // 逆向处理数据 获取后进行数据处理回显
    downloadProcessData(data) {
      const {
        provinceCode = "",
        cityCode = "",
        districtCode = "",
        // -1 => ""
        specialFieldId,
        technicalMaturity,
        advancedLevel,
        // 去分号
        technologyKeyword,
        applicationNumber,
        imgFiles,
        attachFiles,
        ...others
      } = data;
      // 处理 applicationNumber
      const applicationList =
        this.turnNulltoString(applicationNumber).split(";");
      // 处理 technologyKeyword
      const keywordList =
        this.turnNulltoString(technologyKeyword) === ""
          ? []
          : this.turnNulltoString(technologyKeyword).split(";");
      // 处理文件
      const turnFile = {
        imgUploadList: imgFiles,
        fileUploadList: attachFiles
      };
      Object.keys(turnFile).map((key) => {
        const file = this.turnNulltoString(turnFile[key]);
        turnFile[key] = file === "" ? [] : file;
      });
      // 处理数字 转为字符串
      const turnNumber = {
        specialFieldId,
        technicalMaturity,
        advancedLevel
      };
      Object.keys(turnNumber).map((key) => {
        turnNumber[key] = turnNumber[key] === -1 ? "" : turnNumber[key];
      });

      return {
        ...others,
        ...turnNumber,
        ...turnFile,
        regionAddress: [provinceCode, cityCode, districtCode],
        keywordList,
        applicationList
      };
    },
    // 点击添加数据按钮
    handlerAddData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadAddData();
        }
      });
    },
    // 点击修改数据按钮
    handlerModifyData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadModifyData();
        }
      });
    },
    // 点击审核数据
    handlerAuditData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadAuditData();
        }
      });
    },
    // 加载添加数据接口
    loadAddData() {
      this.isLoading = true;
      const params = this.processDataSubmit();
      this.$api(
        "achievement",
        this.isProd ? "addProdAch" : "addTechAch",
        params
      ).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.redirectTo();
        }
      });
    },
    // 加载修改数据接口
    loadModifyData() {
      this.isLoading = true;
      const params = this.processDataSubmit();
      const { id } = this.$route.query;
      this.$api("achievement", this.isProd ? "addProdAch" : "addTechAch", {
        ...params,
        id
      }).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.redirectTo();
        }
      });
    },
    // 加载审核数据接口
    loadAuditData() {
      this.isLoading = true;
      const { id } = this.$route.query;
      this.$api("achievement", "auditAch", {
        ...this.auditForm,
        id
      }).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.redirectTo();
        }
      });
    },
    // 加载数据接口
    loadInfo() {
      const { id } = this.$route.query;
      this.$api("achievement", "getAchInfo", { id }).then((res) => {
        const { code, message } = res;
        if (code === 0) {
          this.form = this.downloadProcessData(res.dataList[0]);
        } else {
          this.$message.error(message);
          this.redirectTo();
        }
      });
    },
    // 返回列表页
    redirectTo() {
      // this.redirectByPath(`/admin/dataManage/achievementList`);
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="less" scoped></style>
